<template>
  <div class="tc-editor">
    <div class="tc-editor-container">
      <div v-if="state.history.length" class="tc-editor-controls">
        <el-button
          class="r-button tc-controls-button"
          :loading="state.loading"
          :disabled="!!multiFeatures.length"
          size="mini"
          type="success"
          @click="saveData"
        >
          Сохранить
        </el-button>
      </div>

      <mode-switcher
        :state="state"
        :draw="draw"
        :map="map"
        @toggle-mode="toggleMode"
        @open-gcp-card="openGcpCard"
      />

      <traffic-counts-layers
        :state="state"
        @toggle-editing-layer="toggleEditingModelLayer"
      />

      <editor-history
        style="margin-top: 12px;"
        :editor-state="state"
        @change-history-step="changeHistoryStep"
        @clear-editing-state="clearEditingState"
      />
    </div>
    <traffic-count-help />
  </div>
</template>

<script>
import ModeSwitcher from "./tc-modes";
import EditorHistory from "@/components/map/components/map-editor/editor-history";
import TrafficCountsLayers from "./tc-layers";
import TrafficCountHelp from "./tc-help";

export default {
  props: ["map", "draw", "state", "controller"],
  components: {
    ModeSwitcher,
    TrafficCountsLayers,
    EditorHistory,
    TrafficCountHelp
  },
  computed: {
    multiFeatures() {
      return this.state.multiFeatures;
    }
  },
  methods: {
    toggleMode(mode) {
      this.controller.toggleEditorMode(mode);
    },
    toggleVisibleModelLayer({ id, e }) {
      e.stopPropagation();
      this.controller.toggleVisibleModelLayer(id);
    },
    toggleEditingModelLayer(id) {
      this.controller.toggleEditingModelLayer(id);
    },
    changeHistoryStep(type) {
      this.controller.changeHistoryStep(type);
    },
    clearEditingState() {
      this.controller.clearEditingState();
    },
    saveData() {
      this.controller.saveData();
    },
    openGcpCard() {
      this.$emit("open-gcp-card");
    }
  }
};
</script>

<style lang="scss">
.tc-editor {
  display: flex;
  flex-direction: column;
  flex: 1;

  &-container {
    padding: 16px;
    flex: 1;
  }

  &-controls {
    margin-bottom: 16px;

    .r-button {
      width: 100%;
    }
  }
}
</style>
